import { render } from "./tableComponent.vue?vue&type=template&id=4af724d1&scoped=true"
import script from "./tableComponent.vue?vue&type=script&lang=js"
export * from "./tableComponent.vue?vue&type=script&lang=js"

import "./tableComponent.vue?vue&type=style&index=0&id=4af724d1&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af724d1"]])

export default __exports__